import { heapEvent } from '@equipmentshare/heaper'
import { DesignSystemProvider } from 'contexts/design-system'
import { Part } from '../../../../../graphql'
import useCreatePartHandler from '../../../parts/effects/create-part'
import useUpdatePartHandler from '../../../parts/effects/update-part'
import useMergePartsHandler from '../../../parts/effects/merge-parts'
import AddEditProduct from '../AddEditProduct'
import MergeProductsForm from '../MergeProductsForm'
import { ProductFormState } from '../ProductForm'

// Modal bodies render in the app-shell ActionModal, outside the view's provider, so each brings its own.

type ModalBodyProps = {
	onCancel: () => void,
	onSuccess: () => void,
}

export function AddProductModal( { onCancel, onSuccess }: ModalBodyProps ) {
	const createPart = useCreatePartHandler()

	return (
		<DesignSystemProvider value="mui">
			<AddEditProduct
				onCancel={() => {
					heapEvent( 'Inventory - Add Part Modal - Click - Cancel', {} )
					onCancel()
				}}
				onSubmit={async( partArgs ) => {
					heapEvent( 'Inventory - Add Part Modal - Click - Submit', {} )
					return await createPart( partArgs )
				}}
				onSuccess={onSuccess}
			/>
		</DesignSystemProvider>
	)
}

export type EditProductModalProps = ModalBodyProps & {
	onMerge: ( part: Part ) => void,
	formData: ProductFormState,
	part?: Part,
}

export function EditProductModal( { formData, onCancel, onSuccess, onMerge, part }: EditProductModalProps ) {
	const updatePart = useUpdatePartHandler()

	return (
		<DesignSystemProvider value="mui">
			<AddEditProduct
				canMerge
				onMerge={onMerge}
				onCancel={() => {
					heapEvent( 'Inventory - Edit Part Modal - Click - Cancel', {} )
					onCancel()
				}}
				onSubmit={async( partArgs ) => {
					heapEvent( 'Inventory - Edit Part Modal - Click - Submit', {} )
					return await updatePart( partArgs )
				}}
				onSuccess={onSuccess}
				part={part}
				formData={formData}
			/>
		</DesignSystemProvider>
	)
}

export type MergeProductsModalProps = ModalBodyProps & {
	formData: { part?: Part },
}

export function MergeProductsModal( { formData, onCancel, onSuccess }: MergeProductsModalProps ) {
	const mergeParts = useMergePartsHandler()

	return (
		<DesignSystemProvider value="mui">
			<MergeProductsForm
				fromPart={formData.part}
				onCancel={() => {
					heapEvent( 'Inventory - Merge Parts Modal - Click - Cancel', {} )
					onCancel()
				}}
				onSubmit={async( goodId, dupeId ) => {
					heapEvent( 'Inventory - Merge Parts Modal - Click - Submit', {} )
					return await mergeParts( goodId, dupeId )
				}}
				onSuccess={onSuccess}
			/>
		</DesignSystemProvider>
	)
}
